import { useQueryClient } from "@tanstack/react-query";

import { usePatchUserSettingsUserId } from "../../../api/generated/user-settings/user-settings";

import { getUserSettingsQueryKey } from "./useUserSettingsQuery";

export function useUpdateUserSettingsMutation() {
    const client = useQueryClient();

    return usePatchUserSettingsUserId({
        mutation: {
            onSuccess: (_, { userId }) => {
                client.invalidateQueries({
                    queryKey: getUserSettingsQueryKey(userId),
                });
            },
        },
    });
}
